import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { RelatorioModel } from 'app/model/relatorio/relatorioModel';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { RelatorioService } from 'app/service/cliente/relatorio.service';
import { PermissoesService } from 'app/service/usuario/permissoes.service';

import { CriarRelatorioComponent } from './criar-relatorio/criar-relatorio.component';

@Component({
  selector: "app-config-relatorio",
  templateUrl: "./config-relatorio.component.html",
  styleUrls: ["./config-relatorio.component.scss"],
})
export class ConfigRelatorioComponent implements OnInit {
  @ViewChild("categoryPaginator", { read: MatPaginator })
  paginator: MatPaginator;
  @ViewChild("usersPaginator") usersPaginator: MatPaginator;
  @ViewChild(MatPaginator) paginatorRelatorio: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) sortRelatorio: MatSort;
  loading = true;
  arrayString: string;
  creatorRel = false;
  editorRel = false;
  listaRel = false;
  deletaRel = false;
  superUser = false;

  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  paginatorLength = 0;

  adm = true;
  acervo = false;
  solicitacao = false;
  usuariosAuth: any[] = [];
  usuariosBD: any[] = [];

  public submit = false;
  relatorio = {} as RelatorioModel;
  relatorios: RelatorioModel[];
  relSelected: number = null;

  usuarios: any[] = [];

  public clienteId: any;

  public mensagemErro: string;

  displayedColumns = ["name", "description", "ative"];

  displayedColumnsUser = ["nome", "acoes"];
  dataSource = new MatTableDataSource<any[]>([]);
  dataSourceRelatorio = new MatTableDataSource<RelatorioModel>([]);

  pesquisaForm: FormGroup;
  pesquisaFormArray: FormArray;

  constructor(
    public dialog: MatDialog,
    public relatorioService: RelatorioService,
    public clientService: ClienteService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService
  ) {
    this.route.params.subscribe(
      (params) => {
        this.clienteId = params["id"];
        this.getPermissionCliente(this.clienteId);
      },
      (err) => {
        // console.error(err);
        this.openSnackBarError(
          "Erro ao buscar id da Empresa, tente novamente mais tarde"
        );
      }
    );
  }

  ngOnInit() {
    // this.clientService.getClienteUnico(this.clienteId).subscribe(
    //   (data) => {
    //     this.formRelatorio.get("cliente").setValue(data);
    //   },
    //   (err) => {
    //     this.openSnackBarError(
    //       "Erro ao buscar Empresa, tente novamente mais tarde"
    //     );
    //   }
    // );

    this.getRelatoriosByIdCliente(this.clienteId);
  }

  openModalCreateRelatorio() {
    console.log(this.clienteId);
    const dialogRef = this.dialog.open(CriarRelatorioComponent, {
      data: { idCliente: this.clienteId },
      disableClose: true,
      width: "100%",
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.getRelatoriosByIdCliente(this.clienteId);
        }
      },
      (error) => {
        console.log(error);
        this.openSnackBarError("Desculpe, ocorreu um erro.");
      }
    );
  }

  getPermissionCliente(idCliente: number) {
    this.loading = true;
    this.permissionService.getPermissionEmpresa(idCliente).subscribe(
      (data) => {
        const arrayAuthorityCliente: any[] = [];
        data.forEach((el) => {
          arrayAuthorityCliente.push(el.authority);
        });
        this.permissionService.setItemAuthority(
          "authority-Empresa",
          arrayAuthorityCliente
        );
        this.getAuthority();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        console.error(err);
        this.openSnackBarError("Ocorreu um erro, tente novamente mais tarde");
      }
    );
  }

  getAuthority() {
    this.arrayString =
      this.permissionService.getItemAuthority("authority-Empresa");
    if (this.arrayString.includes("SUPER_USER")) {
      this.superUser = true;
    }
    if (this.arrayString.includes("LIST_RELATORIO")) {
      this.listaRel = true;
    }
    if (this.arrayString.includes("ADD_RELATORIO")) {
      this.creatorRel = true;
    }
    if (this.arrayString.includes("EDIT_RELATORIO")) {
      this.editorRel = true;
    }
    if (this.arrayString.includes("DELETE_RELATORIO")) {
      this.deletaRel = true;
    }
    if (this.superUser || this.deletaRel || this.editorRel) {
      this.displayedColumns.push("acoes");
    }
  }

  getUsuarios() {
    // onst dialogRef = this.dialog.open(NodeEditDialogComponent, {
    //   data: { clientId: this.clienteId, node },
    //   width: largura,
    // });
    // dialogRef.afterClosed().subscribe(
    //   (result) => {
    //     console.log(result)
    //   },
    //   (err) => {
    //     this.openSnackBarError(
    //       "Ocorreu um erro, tente novamente em alguns instantes"
    //     );
    //   }
    // );

    this.relatorioService.getUsuariosPorCliente(this.clienteId).subscribe(
      (data) => {
        this.usuarios = data.map((element) => ({
          id: element.id,
          nome: element.nome,
        }));
        this.dataSource = new MatTableDataSource(this.usuarios);
        this.dataSource.paginator = this.usersPaginator;
        this.paginatorLength = this.usuarios.length;
        this.dataSource.sort = this.sort;
      },
      (err) => {
        console.error(err);
        this.openSnackBarError(
          "Erro ao buscar Usuários, tente novamente mais tarde"
        );
      }
    );
  }

  getRelatoriosByIdCliente(id: number) {
    this.relatorioService.getRelatoriosPorCliente(id).subscribe(
      (data) => {
        console.log(data);
        this.relatorios = data;
        this.dataSourceRelatorio = new MatTableDataSource(this.relatorios);
        this.dataSourceRelatorio.paginator = this.paginatorRelatorio;
        this.dataSourceRelatorio.sort = this.sortRelatorio;
      },
      (error) => {
        console.error(error);
        this.openSnackBarError(
          "Erro ao buscar Relatórios, tente novamente mais tarde"
        );
      }
    );
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  aplicarFiltrosRel(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSourceRelatorio.filter = filter;
  }

  setRelSelected(id) {
    this.relSelected = id;
  }

  deletarRelatorio() {
    this.relatorioService.deletarRelatorio(this.relSelected).subscribe(
      () => {
        this.getRelatoriosByIdCliente(this.clienteId);
        this.openSnackBarSuccess("Relatório excluído com sucesso !");
      },
      (err) => {
        this.openSnackBarError("Erro ao tentar excluir o Relatório !");
        console.error(err);
      }
    );
  }

  getDadosRelatorioEdit(relatorio: RelatorioModel) {
    console.log(relatorio);
    const dialogRef = this.dialog.open(CriarRelatorioComponent, {
      data: { idCliente: this.clienteId, dataEdit: relatorio },
      disableClose: true,
      width: "100%",
    });

    dialogRef.afterClosed().subscribe((data) => {
      console.log(data);
      this.getRelatoriosByIdCliente(this.clienteId);
    });
  }

  getUsuariosRelatorioBD(idRelatorio: number) {
    this.relatorioService.getUsersByRelatorioId(idRelatorio).subscribe(
      (data) => {
        this.usuariosBD = data;
        this.getUsuarios();
        this.usuariosAuth = this.usuariosBD;
      },
      (err) => {
        console.error(err);
        this.openSnackBarError(
          "Erro ao buscar usuários, tente novamente mais tarde"
        );
      }
    );
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/config-relatorio/config-relatorio.component.ts